import React from 'react';
import { FormControl, InputLabel, OutlinedInput, InputAdornment, FormHelperText } from '@mui/material';
import { Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import ErrorIcon from '@mui/icons-material/Error';

const MobileNumberInput = ({ control, name, label, rules, errors, handleBlur, handleFocus, disabled }) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
            <InputMask
                mask="999-999-9999"
                maskChar=""
                value={field.value}
                onChange={field.onChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
            >
                {(inputProps) => {
                    const hasValue = field.value && field.value.trim() && field.value.trim() !== '';
                    return (
                    <FormControl variant="outlined" fullWidth margin="normal" error={!!errors[name]}>
                        <InputLabel htmlFor={name} shrink={hasValue}>{label}</InputLabel>
                        <OutlinedInput
                            {...inputProps}
                            id={name}
                            name={name}
                            disabled={disabled || false}
                            notched={hasValue}
                            // startAdornment={<InputAdornment position="start"></InputAdornment>}
                            endAdornment={
                                errors[name] ? (
                                    <InputAdornment position="end">
                                        <ErrorIcon style={{ color: 'red' }} />
                                    </InputAdornment>
                                ) : null
                            }
                            label={label}
                        />
                        <FormHelperText>{errors[name]?.message}</FormHelperText>
                    </FormControl>
                    );
                }}
            </InputMask>
        )}
    />
);

export default MobileNumberInput;